import React, {useEffect, useRef, useState, useContext} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import InputFieldCountry from '../../base-components/base-input-country';
import { CountryContext } from '../../../contexts/country-context';
import countriesData from 'assets/data/country-data.json'


const PlaceOfBirthStep = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext, getStep }) => {
    const form = useRef()
    const value = useContext(CountryContext)
    const d = getDataFromContext(step_ID)
    const lang = localStorage.getItem("language")

    const [data, setData] = useState(d)
    

    const [countriesFULL] = useState(countriesData.map(ctr => ({
        name: ctr.translations[lang.toLocaleLowerCase()],
        callingCode: ctr.callingCodes[0],
        code: ctr.altSpellings[0],
        translation: {
            de: ctr.translations.de,
            fr: ctr.translations.fr,
            nl: ctr.translations.nl
        }
    })))
    const BE = countriesFULL.find(ct => {
        return ct.code === "BE"
    })

    // const BE = value?.defalutCountry
    const defaultBirthPlace = data?.internal_postal_input ? data?.internal_postal_input : ""
    const dataCountry = data ? {
            name: data?.internal_placeOfBirth_country,
            code: data?.birth_country
        } : BE
    
    const [selectedCountry, setSelectedCountry] = useState("BE")
    const [inputValue, setInputValue] = useState(defaultBirthPlace ? defaultBirthPlace : "")
    const [defaultCounty, setDefaultCounty] = useState(dataCountry)
    const [isValid, setIsValid] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [cityIsChoosen, setCityIsChoosen] = useState(data?.internal_postal_input !== "")


    const getInputValue = (name, value) => {
        if (value) {
            setDefaultCounty({
                name: value.name,
                code: value.code
            })
            setSelectedCountry(value.code)
            setDataToContext(step_ID, step_URL, "birth_country", value.code)
            setDataToContext(step_ID, step_URL, "internal_placeOfBirth_country", value.name )
        }
        setInputValue("")
    }

    const getCity = (name, value) => {  
        console.log(name,  "=",  value)
        if (value.length > 0 && name === "city") {
            setInputValue(value)
            setDataToContext(step_ID, step_URL, "birth_place", value) 
        }else if (value.length > 0 ) {
            setInputValue(value)
            setDataToContext(step_ID, step_URL, "internal_postal_input", value)
            setDataToContext(step_ID, step_URL, "birth_place", value.split('(')[0].trim()) 
        }

    }

    useEffect(() => {
        setIsValid(isValidForm())
     }, [selectedCountry, inputValue])

    useEffect(() => {
        // console.log("data=> ", data)
        if (window.PageBus) {
            window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "1",
                stepName: "personal info:birth place",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
            } );
        }
        
        getStep(["birth_country", "birth_place", "internal_postal_input", "internal_placeOfBirth_country"]).then(res => console.log("resssss => ", res))
     }, [])
    
    const action = () => {
         _step_service({step_ID, setIsLoading, next_step})
    }

    const getPostalValidity = (bool) => {
        setCityIsChoosen(bool)
    }

    const isValidForm = () => {
       return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " " && cityIsChoosen
        })
    }
    return (
        <>
            <StepsLoader loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('personal_infos.Personal_info_birth_place.title')}</h3>
                        {step_form.map(input => (
                        <InputFieldCountry
                            label={t(input.label)}
                            name={input.id}
                            getInputValue={getInputValue}
                            key={input.id}
                            error={error}
                            type={input.type}
                            value={defaultCounty}
                            useDefault={true}
                            />))}
                        
                        {selectedCountry === "BE" && 
                            <InputField
                                type={"postCode"}
                                label={t('personal_infos.Personal_info_birth_place.place_label')}
                                getInputValue={getCity}
                            value={inputValue}
                            getPostalValidity={getPostalValidity}
                            />
                        }
                        
                        {selectedCountry !== "BE" && 
                            <InputField
                                label={t('personal_infos.Personal_info_birth_place.place_label')}
                                getInputValue={getCity}
                                value={inputValue}
                            />
                         } 
         
                    </BaseParagraph>
                </form>
                <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={!isValid} />
              </StepsLoader>
        </>
    )
}

PlaceOfBirthStep.propTypes = {
    error: PropTypes.array,
    _step_service: PropTypes.func,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
}

PlaceOfBirthStep.defaultProps = {
    name: "email-step"
}


export default PlaceOfBirthStep